export const FACTURA_GENERAL = 1;
export const FACTURA_RESTAURANTE = 2;
export const FACTURA_ECOMMERCE = 3;
export const FACTURA_CONSULTAS = 4;
export const FACTURA_MOTO = 5;

export const EXITO = 200;
export const FACTURADO = -3001;
export const MOTO = -4;
export const ERROR_FACTURA = -3009;

export const ERROR = 400;
export const NO_DATA = 204;

export const GENERICO = 1;
export const EXTRANJERO = 2;

export const FISICA = 1;
export const MORAL = 2;

export const GENERICO_RFC = 'XAXX010101000';
export const EXTRANJERO_RFC = 'XEXX010101000';

